// Gun part-kit contract (research-artAudio §2 "Gun generator"). Guns are built in a local space ("gu"):
// muzzle to the +x side, the barrel axis on y = 0. assemble.ts fits the union of the parts into the cell,
// rotated to −25° (muzzle to the upper right, UX §6.3).

import type { ArtPalette } from '../../palette.ts';
import { type Part, part } from '../../passes.ts';
import { box, rrect } from '../../shapes.ts';

export interface GunRecipe {
  tier: number;
  /** Body colour tokens: none may sit in the 25–70° blaze hue band (palette.json rules). */
  main: string;
  second: string;
  accent: string;
  gripTok: string;
  receiver: { kind: 'round' | 'box' | 'can' | 'long'; x: number; y: number; w: number; h: number };
  barrel: { kind: 'tube' | 'rib' | 'fins' | 'fat'; x: number; len: number; th: number };
  muzzle: { len: number; th: number };
  grip: { x: number; w: number; len: number; deg: number };
  stock: { kind: 'none' | 'stub' | 'full'; len: number; h: number };
  mag: { kind: 'none' | 'cylinder6' | 'hopper' | 'pump' };
  top: { kind: 'none' | 'sight' | 'starScope' | 'cork' };
  decal: { kind: 'dots' | 'stripe' | 'star' | 'bubbles' | 'chevron' };
}

export interface GunKit {
  pal: ArtPalette;
  r: GunRecipe;
  /** Outline / detail widths in gu. */
  ow: number;
}

/** A local rounded-rect part. */
export function lrect(
  g: GunKit,
  tok: string,
  x: number,
  y: number,
  w: number,
  h: number,
  r: number,
  extra: Partial<Part> = {},
): Part {
  return part(rrect(x, y, w, h, r), g.pal.sw(tok), box(x, y, w, h), extra);
}
